import React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from "moment";

import "react-day-picker/lib/style.css";
import "../../css/DateTextBox.css";

import { Input, Icon, SemanticShorthandItem, HtmlInputrops } from "semantic-ui-react";

import {
  formatDate,
  parseDate,
  isValidDate,
  formatMissingDate,
  isValidADDate,
} from "react-lib/utils/dateUtils";
import { useIntl } from "react-intl";

// For more information about this implementation
// see: http://react-day-picker.js.org/examples/elements-year-navigation
function YearMonthForm(props: any) {
  let months = props.useAdDate
    ? [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ]
    : [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];

  const fromMonth = props.fromMonth.getFullYear();
  const toMonth = props.toMonth.getFullYear();
  const years = props.range(
    props.useAdDate ? fromMonth : fromMonth + 543,
    props.useAdDate ? toMonth + 1 : toMonth + 543 + 1
  );
  const monthOptions = months.map((month: any, i: number) => ({
    text: month,
    value: i,
  }));
  const yearOptions = years.map((year: any) => ({ text: year, value: year }));
  const selectedMonth = props.date.getMonth();
  const selectedYear = props.date.getFullYear();

  return (
    <div className="YearMonthForm">
      <div className="ui tiny form">
        <select
          className="month"
          name="month"
          value={selectedMonth}
          onChange={(e) =>
            props.onYearMonthChange(
              new Date(selectedYear, e.target.form ? e.target.form.month.value : e.target.value)
            )
          }
        >
          {monthOptions.map((item: any) => (
            <option key={item.text} value={item.value}>
              {item.text}
            </option>
          ))}
        </select>

        <select
          className="year"
          name="year"
          value={props.useAdDate ? selectedYear : selectedYear + 543}
          onChange={(e) => {
            let yearValue = e.target.form?.year?.value;
            let targetValue = parseInt(e.target.value);

            if (!props.useAdDate) {
              yearValue -= 543;
              targetValue -= 543;
            }
            props.onYearMonthChange(
              new Date(e.target.form ? yearValue : targetValue, selectedMonth)
            );
          }}
        >
          {yearOptions.map((item: any) => (
            <option key={item.text} value={item.value}>
              {item.text}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

class InputWithIcon extends React.Component<any, any> {
  // We must implement focus() method in order to keep DayPickerInput
  // focusing our InputWithIcon while user is picking a day.
  // see: http://react-day-picker.js.org/api/DayPickerInput#component

  ref: any;

  handleRef = (ref: any) => {
    this.ref = ref;
  };

  focus = () => {
    this.ref.focus();
  };

  handleTodayClick = () => {
    this.props.onTodayClick(formatDate(moment()));
  };

  shouldComponentUpdate(nextProps: any) {
    // To prevent cursor position jumping
    const conditions =
      nextProps.value !== this.props.value ||
      nextProps.placeholder !== this.props.placeholder ||
      nextProps.error !== this.props.error ||
      nextProps.disabled !== this.props.disabled;
    return conditions;
  }

  render() {
    const { onTodayClick, inputStyle, inputIcon, ...rest } = this.props;
    // console.log("InputWithIcon this.props" ,this.props)
    return (
      <Input
        style={inputStyle}
        id={this.props.id}
        {...rest}
        ref={this.handleRef}
        maxLength={10}
        onClick={this.props.onClick}
        icon={
          inputIcon ? (
            <Icon name="calendar" link={this.props.readOnly} onClick={this.handleTodayClick} />
          ) : undefined
        }
      />
    );
  }
}

class OverlayComponent extends React.Component<any, any> {
  shouldComponentUpdate(nextProps: any) {
    // we will rerender the OverlayComponent if
    // - the date string in the Input is a correct date format
    // - user clicks something in the Calendar UI
    return (
      isValidDate(formatDate(nextProps.selectedDay)) || isValidDate(formatDate(nextProps.month))
    );
  }

  render() {
    const { input, selectedDay, month, children, classNames, ...props } = this.props;

    return (
      <div className={classNames.overlayWrapper} {...props}>
        <div className={classNames.overlay}> {children} </div>
      </div>
    );
  }
}

class CustomDayPickerInput extends DayPickerInput {
  handleDayClick = (day: any, modifiers: any, e: any) => {
    const { dayPickerProps, inputProps, formatDate } = this.props;

    if (dayPickerProps?.onDayClick) {
      dayPickerProps.onDayClick(day, modifiers, e);
    }

    // Do nothing if the day is disabled
    if (
      modifiers.disabled ||
      (dayPickerProps && dayPickerProps.classNames && modifiers[dayPickerProps.classNames.disabled])
    ) {
      return;
    }

    if ((inputProps as any).onChange) {
      (inputProps as any).onChange(formatDate?.(day, "", ""));
    }

    // @ts-ignore
    this.hideAfterDayClick();
  };
  handleInputChange = (e: any) => {
    const { inputProps } = this.props;

    if ((inputProps as any).onChange) {
      (inputProps as any).onChange(e.target.value);
    }
  };
}

type DateTextBoxProps = {
  onChange: (date: string) => void;
  onClick?: any;
  onBlur?: any;
  placeholder?: any;
  value: any;
  minDate?: any;
  maxDate?: any;
  error?: any;
  disabled?: any;
  size?: any;
  inputClassNames?: any;
  overlayClassNames?: any;
  overlayWrapperClassNames?: any;
  style?: any;
  inputStyle?: any;
  inputFluid?: any;
  inputRef?: any;
  inputIcon?: any;
  tabIndex?: any;
  ref?: any;
  readOnlyInputProps?: any;
  backYear?: any;
  useAdDate?: boolean;
  setLanguage?: any;
  keepFocus?: any;
  closeOnComplete?: boolean;
  id?: any;
  autoAdBe?: boolean;
  forwardYear?: number;
  input?: SemanticShorthandItem<HtmlInputrops>;
  adFormat?: string;
  disabledDays?: string[];
  isDisabledDays?: boolean;
  onMonthChange?: (month: string) => void;
};

class DateTextBox extends React.Component<DateTextBoxProps, any> {
  monthChangedByDayPicker: any;
  datePickerRef: any;
  root = React.createRef<HTMLDivElement>();
  fromMonth: any;
  toMonth: any;
  range: any;
  static defaultProps = {
    placeholder: "",
    error: false,
    onChange() {},
    inputClassNames: "",
    overlayClassNames: "",
    overlayWrapperClassNames: "",
    style: {},
    tabIndex: 0,
    keepFocus: true,
    closeOnComplete: false,
    inputStyle: null,
    inputFluid: false,
    inputRef: () => {},
    onClick: () => {},
    onBlur: () => {},
    backYear: 100,
    useAdDate: false,
    setLanguage: "th",
    onMonthChange: () => {},
  };

  constructor(props: any) {
    super(props);

    const currentYear = new Date().getFullYear();

    this.state = {
      month: null,
    };
    // This property is used to check whether the month (in DayPicker UI)
    // is changed by clicking on UI or by typing in InputWithIcon
    this.monthChangedByDayPicker = false;
    this.datePickerRef = React.createRef();
    // Start from currentYear - 100
    this.fromMonth = new Date(currentYear - props.backYear, 0);
    // End at currentYear + 10
    this.toMonth = new Date(currentYear + (props.forwardYear ?? 10), 11);
    // Suggested by: https://stackoverflow.com/a/36963945
    this.range = (start: any, end: any) => Array.from({ length: end - start }, (v, k) => k + start);
  }

  handleYearMonthChange = (month: any) => {
    this.monthChangedByDayPicker = true;
    this.setState({ month });

    this.props.onMonthChange?.(month);
  };

  handleTextChange = (text: any) => {
    this.props.onChange(text);
    if (this.props.closeOnComplete && typeof text === "string") {
      const complete = this.getUseAdDate()
        ? moment(text, this.props.adFormat || "DD/MM/YYYY", true).isValid()
        : /^\d{2}\/\d{2}\/\d{4}$/.test(text) && formatDate(parseDate(text)) === text;
      if (complete) this.datePickerRef?.hideDayPicker();
    }
  };

  handleBlur = (e: any) => {
    this.props.onBlur();
  };

  handleClick = (e: any) => {
    this.props.onClick();
  };

  getUseAdDate = () => {
    if (this.props.autoAdBe) {
      if (!this.props.value) {
        return this.props.useAdDate;
      }

      return isValidADDate(this.props.value, !this.props.useAdDate, this.props.adFormat);
    }

    return this.props.useAdDate;
  };

  getLanguage = () => {
    if (this.props.autoAdBe) {
      if (!this.props.value) {
        return this.props.setLanguage;
      }

      return isValidADDate(this.props.value) ? "en" : this.props.setLanguage;
    }

    return this.props.setLanguage;
  };

  getFormatDate = (date: Date) => {
    if (this.props.autoAdBe) {
      return this.getUseAdDate()
        ? moment(date).format(this.props.adFormat) // AD format
        : formatDate(date); // BE format
    }

    return formatDate(date);
  };

  convertStringToDate = (str: string) => {
    const adPattern = /\d{4}-\d{2}-\d{2}/;

    if (this.getUseAdDate() && adPattern.test(str || "")) {
      return new Date(str);
    } else if (this.getUseAdDate()) {
      const formatted = formatMissingDate(str, "YYYY-MM-DD");

      return formatted ? new Date(formatted) : null;
    } else {
      const formatted = formatMissingDate(str);

      return formatted ? parseDate(formatted) : null;
    }
  };

  handleDayPickerShow = () => {
    const overlay = this.datePickerRef?.daypicker?.dayPicker?.parentElement;

    if (!overlay) {
      return;
    }

    const rect = overlay.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    if (rect.right > viewportWidth) {
      overlay.classList.add("DayPickerInput-Overlay--right");
    } else {
      overlay.classList.remove("DayPickerInput-Overlay--right");
    }
  };

  handleOutsidePointer = (event: Event) => {
    if (this.props.closeOnComplete && !this.root.current?.contains(event.target as Node))
      this.datePickerRef?.hideDayPicker();
  };

  handleEscape = (event: Event) => {
    if (
      this.props.closeOnComplete &&
      (event as KeyboardEvent).key === "Escape" &&
      this.datePickerRef?.state.showOverlay
    ) {
      event.stopPropagation();
      this.datePickerRef.hideDayPicker();
    }
  };

  listenForClose = (listen: boolean) => {
    const method = listen ? "addEventListener" : "removeEventListener";
    document[method]("mousedown", this.handleOutsidePointer, true);
    document[method]("touchstart", this.handleOutsidePointer, true);
    document[method]("keydown", this.handleEscape, true);
  };

  componentDidMount() {
    if (this.props.closeOnComplete) this.listenForClose(true);
  }

  componentWillUnmount() {
    if (this.props.closeOnComplete) this.listenForClose(false);
  }

  // #70431 hideDayPicker
  componentDidUpdate(prevProps: Readonly<DateTextBoxProps>): void {
    if (prevProps.closeOnComplete !== this.props.closeOnComplete)
      this.listenForClose(!!this.props.closeOnComplete);
    if (prevProps?.disabled !== this.props.disabled) {
      this.datePickerRef.hideDayPicker();
    }
  }

  render() {
    const {
      placeholder,
      value,
      minDate,
      maxDate,
      error,
      disabled,
      size,
      inputClassNames,
      overlayClassNames,
      overlayWrapperClassNames,
      style,
      inputStyle,
      inputFluid,
      inputRef,
      inputIcon,
      tabIndex,
      ref,
      readOnlyInputProps,
      backYear,
      input,
      disabledDays,
      isDisabledDays,
    } = this.props;
    // console.log('this.props', this.props)

    const month = this.monthChangedByDayPicker ? this.state.month : this.convertStringToDate(value);

    this.monthChangedByDayPicker = false;

    // console.log(" DateTextBox this.props ", this.props)
    // console.log(" DateTextBox minDate ", minDate, maxDate)
    // console.log(" DateTextBox minDate parseDate(maxDate): ", parseDate(maxDate))
    // console.log(" DateTextBox minDate parseDate(minDate): ", parseDate(minDate))

    let disabledDaysConfig = null;

    if (Array.isArray(disabledDays) && disabledDays.length > 0) {
      disabledDaysConfig = (day: Date) => {
        if (isDisabledDays) {
          return disabledDays;
        } else {
          const dateStr = formatDate(day);
          return !disabledDays.includes(dateStr);
        }
      };
    } else {
      const range = {
        ...(maxDate && { after: parseDate(maxDate) }),
        ...(minDate && { before: parseDate(minDate) }),
      };

      if (Object.keys(range).length > 0) {
        disabledDaysConfig = range;
      }
    }

    const handleMonthChange = (month: string) => {
      this.props.onMonthChange?.(month);
    };

    let isMobile =
      typeof globalThis !== "undefined" ? (globalThis as any).mobile : (window as any).mobile;
    const picker = (
      <CustomDayPickerInput
        ref={(el) => (this.datePickerRef = el)}
        keepFocus={isMobile ? false : this.props.keepFocus}
        style={style}
        component={InputWithIcon}
        inputProps={{
          disabled,
          error,
          onTodayClick: this.handleTextChange,
          onChange: this.handleTextChange,
          onClick: this.handleClick,
          onBlur: this.handleBlur,
          size: size,
          id: this.props.id,
          className: inputClassNames,
          fluid: inputFluid,
          tabIndex: tabIndex,
          readOnly: readOnlyInputProps,
          ref: inputRef,
          inputIcon: inputIcon ?? "calender",
          input: input,
          ...(inputStyle && { inputStyle: inputStyle }),
        }}
        classNames={{
          container: "DayPickerInput " + inputClassNames,
          overlay: "DayPickerInput-Overlay " + overlayClassNames,
          overlayWrapper: "DayPickerInput-OverlayWrapper " + overlayWrapperClassNames,
        }}
        placeholder={placeholder}
        formatDate={this.getFormatDate}
        parseDate={this.convertStringToDate}
        value={value ? value : ""}
        overlayComponent={OverlayComponent}
        onDayPickerShow={this.handleDayPickerShow}
        dayPickerProps={{
          // locale: "th",
          locale: this.getLanguage(),
          localeUtils: MomentLocaleUtils,
          month: month, // Only used to change the month in the UI (it has nothing to do with changing the day in the UI)
          fromMonth: this.fromMonth,
          toMonth: this.toMonth,
          ...(disabledDaysConfig && {
            disabledDays: [disabledDaysConfig],
          }),
          ...(this.props.onMonthChange && {
            onMonthChange: handleMonthChange,
          }),
          captionElement: (
            <YearMonthForm
              fromMonth={this.fromMonth}
              toMonth={this.toMonth}
              range={this.range}
              backYear={backYear}
              onYearMonthChange={this.handleYearMonthChange}
              useAdDate={this.getUseAdDate()}
            />
          ),
        }}
      />
    );
    return this.props.closeOnComplete ? <div ref={this.root}>{picker}</div> : picker;
  }
}

export default DateTextBox;
